module.exports = __webpack_public_path__ + "static/media/download-on-google-play.7d7f31e4.png";